import { render, staticRenderFns } from "./ExampleTable.vue?vue&type=template&id=5e417160&scoped=true"
import script from "./ExampleTable.vue?vue&type=script&lang=js"
export * from "./ExampleTable.vue?vue&type=script&lang=js"
import style0 from "./ExampleTable.vue?vue&type=style&index=0&id=5e417160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e417160",
  null
  
)

export default component.exports